import React, { useEffect, useState } from 'react'
import { Steps } from '../Step/Steps'
import { Button, Col, Image, Modal, Row, Upload } from 'antd'
import {
  CloseOutlined,
  CheckOutlined,
  UploadOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import { Add_AdditionalFile_Api, Delete_AdditionalFile_Api, GetAll_AdditionalFile_Api } from '../../API/AdditionalFileApi';
// =================================================================
export const AdditionalFilesComponent = ({ setLoading,
  showMessage,
  reserve,
  period,
  isShowComment=true,
  //readOnly = false // ✅ پراپ جدید برای حالت فقط خواندنی
  readOnly: propReadOnly = false // ✅ پراپ ورودی readOnly را به propReadOnly تغییر نام می‌دهیم
}) => {
  // =================================================================
  const [additionalFiles, setAdditionalFiles] = useState(null);
  const [version, setVersion] = useState(0);
  // ✅ منطق تعیین حالت فقط خواندنی (readOnly)
  const isReserveStatusReadOnly = [
    'RejectByAdmin',
    'Accepted',
    'Completed'
  ].includes(reserve?.reserveStatus);
  // نهایی کردن وضعیت readOnly: اگر از پراپ هم readOnly بود، یا از وضعیت رزرو readOnly بود.
  const finalReadOnly = propReadOnly || isReserveStatusReadOnly; 
  // =================================================================
  useEffect(() => {
    loadData();
  }, [version, reserve.id]);
  // =================================================================
  const loadData = async () => {
    setLoading(true);
    try {
      const data = await GetAll_AdditionalFile_Api(reserve.id);
      setLoading(false);
      if (data.messageStatus == "Successful") {
        setAdditionalFiles(data.messageData.data);
        //console.log("data.messageData.data", data.messageData.data)
      }
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  // =================================================================
  const deleteFile = async (id) => {
    setLoading(true);
    try {
      const data = await Delete_AdditionalFile_Api(id);
      setLoading(false);
      if (data.messageStatus == "Successful") {
        showMessage(data.message, "Successful")
      }
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  // =================================================================
  const handleFileChange = async (info) => {
    // انتخاب اولین فایل
    // setFile(info.fileList[0].originFileObj);
    try {
      if (info.fileList.length > 0) {
        setLoading(true);
        //////////////////////////////
        const formData = new FormData();
        if (info.fileList.length > 0)
          formData.append("file", info.fileList[0].originFileObj);

        formData.append("reserveId", reserve.id);

      

        let data = await Add_AdditionalFile_Api(formData);
        setLoading(false);

        if (data.messageStatus == "Successful") {
          showMessage(data.message, "Successful");
          setVersion(version + 1);
        }
        else
          showMessage(data.message, "error");
      }
      else
        showMessage("مشکل در بارگذاری فایل.", "error")

    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور", "error")
    }

  };
  // =================================================================
  return (
    <>
    <Row className='sectionTitle'>
                    <Col span={24}>
                        <h2 >
                            مدارک ثبت نام
                        </h2>
                    </Col>
                </Row> 
      {isShowComment ?
        <div className='container'>
          <Row justify='center' style={{ borderBottom: '1px solid #cdcdcd', paddingTop: '8px', paddingBottom: '8px' }}>
            <Col span={22}>
              <div dangerouslySetInnerHTML={{ __html: period.additionalFileComment }} />
            </Col>
          </Row>
        </div> : <></>
      }
      <div className='container  additional-file-section no-print'>
        <Row>

          {additionalFiles ? <>
            {additionalFiles.map((additionalFile, key) =>
              <Col
              key={key}
                style={{ padding: '5px' }}

                xs={12} sm={12} md={8} lg={4} xl={4}>
                <div
                  style={{ padding: '5px', border: '2px solid #cdcdcd', borderRadius: '10px', textAlign: 'center', height: '100%' }}
                >
                  <Image
                    style={{ border: '2px solid #cdcdcd', borderRadius: '10px' }}
                    src={additionalFile.fileURL} />


                </div>
{/* ✅ دکمه حذف فقط در حالت غیر read-only نمایش داده شود */}
                {!finalReadOnly && (
                  <Button
                    className='btn-danger'
                    style={{ width: '10px', position: 'absolute', top: '15px', right: '15px', borderRadius: '20px' }}
                    onClick={() => {
                      Modal.confirm({
                        title: 'آیا از حذف اطمینان دارید؟',
                        onOk: () => { deleteFile(additionalFile.id); setVersion(version + 1) },
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }}
                  >
                    <CloseOutlined />
                  </Button>
                )}
              </Col>
            )}
          </> : <></>}

          {!finalReadOnly && additionalFiles && additionalFiles.length < period.additionalFileCount ?
            <Col style={{ paddingTop: '5px', minHeight: '130px' }} xs={12} sm={12} md={8} lg={4} xl={4} >
              <div
                style={{ paddingTop: '50px', border: '2px solid #cdcdcd', borderRadius: '10px', textAlign: 'center', height: '100%' }}
              >
                <Upload
                  style={{ width: '100%' }}
                  beforeUpload={() => false}
                  onChange={handleFileChange}
                  accept="image/*"
                  showUploadList={false}
                  maxCount={1}
                >
                  <Button
                    className='btn-primary'
                    style={{ width: '100%' }} icon={<UploadOutlined />}>انتخاب فایل </Button>
                </Upload>
              </div>
            </Col> : <></>
          }

        </Row>
      </div>

    </>
  )
}
